import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { QUIZ_QUESTIONS } from '../../data/quizData';
import Home from '../../pages/Home';
import QuestionScreen from './QuestionScreen';
import ProgressBar from './ProgressBar';
import LeadForm from './LeadForm';
import ResultScreen from './ResultScreen';

const QuizApp = () => {
  const [step, setStep] = useState('start');
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [answers, setAnswers] = useState({});
  const [userData, setUserData] = useState(null);
  const [resultType, setResultType] = useState(null);

  const handleStart = () => setStep('quiz');

  const handleAnswer = (questionId, answerId) => {
    setAnswers(prev => ({ ...prev, [questionId]: answerId }));
    setTimeout(() => {
      if (currentQuestion < QUIZ_QUESTIONS.length) {
        setCurrentQuestion(prev => prev + 1);
      } else {
        setStep('lead');
      }
    }, 400);
  };

  const handleFormSubmit = (data, calculatedResult) => {
    setUserData(data);
    setResultType(calculatedResult);
    setStep('result');
  };

  const renderStep = () => {
    if (step === 'start') {
      return <Home onStart={handleStart} />;
    }

    if (step === 'quiz') {
      const question = QUIZ_QUESTIONS[currentQuestion - 1];
      return (
        <div className="w-full">
          <ProgressBar
            currentStep={currentQuestion}
            totalSteps={QUIZ_QUESTIONS.length}
          />
          <QuestionScreen
            key={question.id}
            question={question}
            onAnswer={handleAnswer}
          />
        </div>
      );
    }

    if (step === 'lead') {
      return (
        <div className="w-full">
          <ProgressBar
            currentStep={QUIZ_QUESTIONS.length}
            totalSteps={QUIZ_QUESTIONS.length}
          />
          <LeadForm onSubmit={handleFormSubmit} answers={answers} />
        </div>
      );
    }

    if (step === 'result') {
      return <ResultScreen resultType={resultType} userData={userData} />;
    }

    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12 flex justify-center">
          <div className="overflow-hidden h-10 md:h-[200px] flex justify-center items-center">
            <img
              src="https://media-manager-c.questera.ai/greta-media/525d05658fdf988acaa34e738d3f286826191483600217441074af5254e1324b9947d16ec384fcc03e2360d22f6a7d9b/images/aW1hZ2UvcG5n/312034cd79c028aad1e85c1e994b94aa.png"
              alt="Pinoy General Insurance Services"
              className="w-72 md:w-96 object-cover h-auto drop-shadow-sm"
            />
          </div>
        </div>
        <AnimatePresence mode="wait">
          {renderStep()}
        </AnimatePresence>
        <div className="text-center mt-12 text-sm text-gray-400">
          <p>© {new Date().getFullYear()} Pinoy General Insurance Services. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default QuizApp;